import { useTranslation } from 'react-i18next';
import { formatMoneyWithSeparators, formatPercentValue } from '@/utils';
import { ICancelledOrdersKpis } from '@/models/cancelledOrders.model';
import DynamicsCell from '../DynamicsCell/DynamicsCell';
import {
  StyledKpiCard,
  StyledKpiHint,
  StyledKpiItem,
  StyledKpiLabel,
  StyledKpiLabelRow,
  StyledKpiTitle,
  StyledKpiValue,
} from './KpiListStyles';
import InfoLabel from '@/modules/Dashboard/components/InfoLabel';

interface IKpiListProps {
  kpis: ICancelledOrdersKpis | null | undefined;
}

const KpiList = ({ kpis }: IKpiListProps) => {
  const { t, i18n } = useTranslation(['dashboard']);
  const ppSuffix = t('cancelled_orders_pp_suffix');

  return (
    <StyledKpiCard>
      <StyledKpiTitle>{t('cancelled_orders_kpi_title')}</StyledKpiTitle>

      <StyledKpiItem>
        <StyledKpiLabelRow>
          <StyledKpiLabel>
            <InfoLabel label={t('cancelled_orders_kpi_count')} tooltip={t('cancelled_orders_kpi_count_tooltip')} />
          </StyledKpiLabel>
          <DynamicsCell value={kpis?.cancelled_count.change_percent} />
        </StyledKpiLabelRow>
        <StyledKpiValue>
          {kpis?.cancelled_count.value ?? 0} {t('cancelled_orders_pcs')}
        </StyledKpiValue>
      </StyledKpiItem>

      <StyledKpiItem>
        <StyledKpiLabelRow>
          <StyledKpiLabel>
            <InfoLabel label={t('cancelled_orders_kpi_amount')} tooltip={t('cancelled_orders_kpi_amount_tooltip')} />
          </StyledKpiLabel>
          <DynamicsCell value={kpis?.cancelled_amount.change_percent} />
        </StyledKpiLabelRow>
        <StyledKpiValue>
          {formatMoneyWithSeparators(kpis?.cancelled_amount.value)} {t('dashboard_grn')}
        </StyledKpiValue>
      </StyledKpiItem>

      <StyledKpiItem>
        <StyledKpiLabelRow>
          <StyledKpiLabel>
            <InfoLabel
              label={t('cancelled_orders_kpi_avg_check')}
              tooltip={t('cancelled_orders_kpi_avg_check_tooltip')}
            />
          </StyledKpiLabel>
          <DynamicsCell value={kpis?.cancelled_avg_check.change_percent} />
        </StyledKpiLabelRow>
        <StyledKpiValue>
          {formatMoneyWithSeparators(kpis?.cancelled_avg_check.value)} {t('dashboard_grn')}
        </StyledKpiValue>
      </StyledKpiItem>

      <StyledKpiItem>
        <StyledKpiLabelRow>
          <StyledKpiLabel>
            <InfoLabel label={t('cancelled_orders_kpi_share')} tooltip={t('cancelled_orders_kpi_share_tooltip')} />
          </StyledKpiLabel>
          <DynamicsCell value={kpis?.cancelled_share_percent.change_pp} suffix={ppSuffix} />
        </StyledKpiLabelRow>
        <StyledKpiValue>
          {formatPercentValue(kpis?.cancelled_share_percent.value ?? 0, 1, i18n.language)}
        </StyledKpiValue>
      </StyledKpiItem>

      <StyledKpiHint>{t('cancelled_orders_kpi_hint')}</StyledKpiHint>
    </StyledKpiCard>
  );
};

export default KpiList;
